import Vue from 'vue'
import MagHistory from './view/MagHistory.vue';

Vue.component('MagHistory', MagHistory);
